import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArkUnitOfWork, AppInformationService, AuthService } from 'app/core/core.module';
import { ContributionBatch } from 'app/core/model/entity-model';
import moment from 'moment';
import _ from 'lodash';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-batch-edit-dialog',
    templateUrl: './batch-edit-dialog.component.html',
    styleUrls: ['./batch-edit-dialog.component.scss'],
    standalone: false,
})
export class BatchEditDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    batchId: number;
    batch: ContributionBatch;
    routerOption: any;
    statuses: any[];
    specialAccounts: any[];
    statusReadOnly = false;
    offeringDate: Date;
    graafschap = false;
    validationGroup = 'validationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, public appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.statuses = await this.uow.contributionBatchStatuses.all();
        this.graafschap = this.appInfo.settings.church.toUpperCase() === 'GRAAFSCHAP';
        this.specialAccounts = await this.uow.getAccounts();
        this.specialAccounts.forEach((account) => {
            account.accountName = `${account.name}${account.quickBooksAccount ? ' - ' + account.quickBooksAccount : ''}`;
        });
        if (this.routerOption === 'new') {
            this.batch = this.uow.contributionBatches.createEntity();
            this.batch.date = !!this.offeringDate ? this.offeringDate : new Date();
            this.batch.statusId = 1;
            this.batch.createdBy = this.auth.currentUser.userName;
            if (this.appInfo.settings.church === 'graafschap') this.batchName();
        } else {
            this.batch = await this.uow.contributionBatches.byId(this.batchId);
        }
        this.statusReadOnly = this.batch.statusId === 5;
    }
    specialAccountChange(e) {
        this.batchName();
    }

    adjustWidth(e) {
        setTimeout(() => {
            e.component._popup?.option('width', 400);
        }, 0);
    }

    batchName() {
        if (this.appInfo.settings.church === 'graafschap') {
            let batchDateStr = '';
            batchDateStr = moment(this.batch.date).format('MM/DD/YYYY');

            let offeringName = '';
            if (!!this.batch.specialAccountId) {
                offeringName = (_(this.specialAccounts).find({ id: this.batch.specialAccountId } as any) as any).name;
            }
            this.batch.name = `${batchDateStr} - ${offeringName}`;
        }
    }

    async save() {
        const result = this.validate();
        if (!result) return;
        // this.batch.date = moment(new Date(), 'YYYY-MM-DD').toDate();
        await this.uow.commit();
        this.result.next({ result: true, batchId: this.batch.id });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
